export default __webpack_public_path__ + "static/media/regulatory--no-overtaking--g5.6b8e21fc.png";